import { requestApi } from 'api/api'
import type {
  CreateLimitPayload,
  CurrencyLimitsResponse,
  Limit,
  LimitHistoryResponse,
  LimitsQueryParams,
  LimitsResponse,
  UpdateLimitPayload,
} from 'types/paymentLimits'

const buildLuceneQuery = (params: LimitsQueryParams): string => {
  const queryFields: Array<{ key: string; value: string | undefined }> = [
    { key: 'accountId', value: params?.accountId },
    { key: 'customerId', value: params?.customerId },
    { key: 'level', value: params?.level },
    { key: 'limitType', value: params?.limitType },
    { key: 'method', value: params?.paymentMethod },
    { key: 'currency', value: params?.currency },
  ]

  return queryFields
    .filter(({ value }) => !!value)
    .map(({ key, value }) => `${key}:${value}`)
    .join(' AND ')
}

export const getPaymentLimits = async (params: LimitsQueryParams): Promise<LimitsResponse> => {
  const q = buildLuceneQuery(params)

  return requestApi({
    url: '/governance/v1/limits',
    method: 'GET',
    params: {
      ...(q && { q }),
      ...(params?.pageNumber !== undefined && { pageNumber: params.pageNumber }),
      ...(params?.pageSize && { pageSize: params.pageSize }),
    },
    baseUrl: process.env.API_URL,
  })
}

export const getCurrencyGlobalLimits = async (currency: string): Promise<CurrencyLimitsResponse> =>
  requestApi({
    url: `/governance/v1/global-limits/currencies/${currency}`,
    method: 'GET',
    baseUrl: process.env.API_URL,
  })

export const createPaymentLimit = async (data: CreateLimitPayload): Promise<Limit> => {
  return requestApi({
    url: '/governance/v1/limits',
    method: 'POST',
    data,
    baseUrl: process.env.API_URL,
  })
}

export const updatePaymentLimit = async ({ id, ...data }: UpdateLimitPayload): Promise<Limit> => {
  return requestApi({
    url: `/governance/v1/limits/${id}`,
    method: 'PUT',
    data,
    baseUrl: process.env.API_URL,
  })
}

export const deletePaymentLimit = async (id: string): Promise<void> => {
  return requestApi({
    url: `/governance/v1/limits/${id}`,
    method: 'DELETE',
    baseUrl: process.env.API_URL,
  })
}

export const getPaymentLimitHistory = async (limitId: string): Promise<LimitHistoryResponse> => {
  return requestApi({
    url: `/governance/v1/limits/${limitId}/history`,
    method: 'GET',
    baseUrl: process.env.API_URL,
  })
}
